import clientAxios from './../../config/axios';
import { RegisterRequest } from './models/RegisterRequest';
import { ILogin } from './state';
export const login = (data: any) => {
  const url = `auth/login?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  data.country = process.env.REACT_APP_ENV_COUNTRY as 'MX' | 'CO';
  return clientAxios.post(url, data);
};

export const googleAuth = (data: ILogin['googleCredentialResponse']) => {
  const url = `auth/google-login`;
  return clientAxios.post(url, {
    data,
    country: process.env.REACT_APP_ENV_COUNTRY as 'MX' | 'CO',
  });
};

export const forgotPasswordService = (data: { email: string }) => {
  const url = `auth/forgot-password`;
  return clientAxios.post(url, {
    email: data.email,
    country: process.env.REACT_APP_ENV_COUNTRY as 'MX' | 'CO',
  });
};

export const register = async (data: RegisterRequest) => {
  const url = `auth/register`;
  data.country = process.env.REACT_APP_ENV_COUNTRY as 'MX' | 'CO';
  const result = await clientAxios.post(url, data);
  return result.data;
};
